var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from "vue-property-decorator";
import { findIndex } from "lodash-es";
var IncrementingNumber = /** @class */ (function (_super) {
    __extends(IncrementingNumber, _super);
    function IncrementingNumber() {
        var _this = _super.call(this) || this;
        _this.name = "incrementing-number";
        _this.count = 1;
        _this.className = "";
        _this.className = "".concat(_this.name, "__").concat(_this.keyName);
        // Why? IE of course
        if (typeof (Event) === 'function') {
            _this.changeEvent = new Event("".concat(_this.className, "--changed"));
        }
        else {
            _this.changeEvent = document.createEvent('Event');
            _this.changeEvent.initEvent("".concat(_this.className, "--changed"), false, false);
        }
        return _this;
    }
    IncrementingNumber.prototype.mounted = function () {
        var _this = this;
        window.addEventListener("".concat(this.className, "--changed"), function () { return _this.onUpdate(); });
        window.dispatchEvent(this.changeEvent);
        this.onUpdate();
    };
    IncrementingNumber.prototype.onUpdate = function () {
        var _this = this;
        this.count = findIndex(document.querySelectorAll(".".concat(this.className)), function (counterElement) { return counterElement == _this.$el; }) + 1;
    };
    ;
    IncrementingNumber.prototype.destroyed = function () {
        var _this = this;
        window.dispatchEvent(this.changeEvent);
        window.removeEventListener("".concat(this.className, "--changed"), function () { return _this.onUpdate(); });
    };
    __decorate([
        Prop(String)
    ], IncrementingNumber.prototype, "keyName", void 0);
    IncrementingNumber = __decorate([
        Component
    ], IncrementingNumber);
    return IncrementingNumber;
}(Vue));
export default IncrementingNumber;
